import { makeActionCreator } from '../../config/store/utils'

export const CHANGE_FIRST_FILTER = 'CHANGE_FIRST_FILTER'
export const onChangeFirstFilter = makeActionCreator(CHANGE_FIRST_FILTER, 'payload')

export const CHANGE_SECOND_FILTER = 'CHANGE_SECOND_FILTER'
export const onChangeSecondFilter = makeActionCreator(CHANGE_SECOND_FILTER, 'payload')
